module.exports = __webpack_public_path__ + "img/salmon.20c30127.jpg";